import React, { useEffect, useState } from "react";
import { useContext } from "react";
import { MemoryCountDownContext } from "../Context/MemoryCountDownContext";
import { MemoryLevelContext } from "../Context/MemoryLevelContext";
import { MemoryTimerContext } from "../Context/MemoryTimerContext";

const GameTimer = () => {

    const {countDownFinished} = useContext(MemoryCountDownContext);
    const {time, setTime, handleTimer, timerOn, getResultTime} = useContext(MemoryTimerContext);
    const {allCardsMatch} = useContext(MemoryLevelContext);
    const [newTime, setNewTime] = useState(0);
 
    useEffect(() => {
        if(countDownFinished){
            handleTimer(true); 
        }
    }, [countDownFinished]);

    useEffect(() => {
        let interval = null;
        if(timerOn){
            interval = setInterval(() => {
                setNewTime(prevTime => prevTime + 10)
            }, 10);
        } else{
            if(newTime != 0){
                setTime(newTime);
            }
            clearInterval(interval);
            setNewTime(0);
        }
        return () => clearInterval(interval);
    }, [timerOn]);

    return(
        <>
        { !allCardsMatch ?
            <div className="game-timer-container">
                <span className="game-timer-container__clock">{("0" + Math.floor((newTime / 60000) % 60)).slice(-2)}:</span>
                <span className="game-timer-container__clock">{("0" + Math.floor((newTime / 1000) % 60)).slice(-2)}:</span>
                <span className="game-timer-container__clock">{("0" + ((newTime / 10) % 100)).slice(-2)}</span>
            </div>
            :
            <div className="game-timer-container">
                <span className="game-timer-container__clock">{("0" + Math.floor((time / 60000) % 60)).slice(-2)}:</span>
                <span className="game-timer-container__clock">{("0" + Math.floor((time / 1000) % 60)).slice(-2)}:</span>
                <span className="game-timer-container__clock">{("0" + ((time / 10) % 100)).slice(-2)}</span>
            </div>
        }
        </>
    );
};

export default GameTimer;